module.exports = __webpack_public_path__ + "media/images/employees_form_box_bg-e864118260c9c0e2b42701217775256e.png";